import NamedSlugTab from './NamedSlugTab';

export default function TagsTab(): JSX.Element {
  return (
    <NamedSlugTab
      endpoint="/admin/tags"
      singular="tag"
      plural="tags"
      placeholder="Nome (ex.: Novidades)"
    />
  );
}
